import React from "react";
import pdfFile from "../pdfs/OnboardingYourUnits-BNB.pdf";
import PdfViewer from "../comman/PdfViewer";
import { onboardingDocs } from "../consfig";
const OnboardingUnits = () => {
  const pdfUrl = onboardingDocs.b2b.onBoardUnits;
  return <PdfViewer pdfFile={pdfUrl} />;
};
export default OnboardingUnits;
